<template>
  <div class="base_container">
    <section id="intro_section_1" class="intro_section">
      <div class="intro_contents_container">
        <div :class="{on:animation.section1_1_on}">
          <p>대표님, 환급금 찾아가세요!</p>
          <!-- Slot 사용여부처리 -->
          <slot v-if="useSection1Slot" name="section1"></slot>
          <p v-else class="clr_blue">3분만에 환급금액 확인 가능! <br/>
            <span class="clr_black">세금환급 플랫폼</span> <span class="forMbl">{{ serviceProviderName }}</span>
          </p>
          <p>지금 바로 예상 환급액을 조회해보세요</p>
          <button @click="mixFnTax">예상 환급액 무료조회</button>
        </div>
        <div>
          <div class="iphone_back">
            <p>세금 환급 조회</p>
            <p><span class="type1">환급 받으실 수</span> 있는 <span class="type1">금액은</span>
              <br/><span class="type2">{{money}}</span>원 입니다.</p>
            <table>
              <thead >
              <tr><td>5년간 환급 가능한 금액</td><td>80,473,000원</td></tr>
              </thead>
              <!-- <tbody  class="tablet_hide"> -->
              <tbody>
              <tr><td>2018</td><td>23,500,000원</td></tr>
              <tr><td>2019</td><td>11,410,000원</td></tr>
              <tr><td>2020</td><td>13,410,000원</td></tr>
              <tr><td>2021</td><td>23,420,000원</td></tr>
              <tr><td>2022</td><td>8,730,000원</td></tr>
              </tbody>
              <!-- <tfoot>
              <tr><td>5년간 매출</td><td>573,000원</td></tr>
              <tr><td>5년간 매출</td><td>573,000원</td></tr>
              </tfoot> -->
            </table>
          </div>
        </div>
      </div>
    </section>
    <section id="intro_section_2" class="intro_section">
      <div>
        <h1 :class="{on:animation.section2_1_on}"><span>{{ serviceProviderName }}</span>에서<br class="mobile_show" /> 지금 바로 조회하세요!</h1>
        <div class="card_list">
          <div class="box">
            <div class="card">
              <div class="icon" />
              <h2>국세청 권장사업!</h2>
              <p>[국세 기본법 제45조의 1]에 의거한 제도로 5년간 과·오납한 세금을 돌려받는 세금 환급 제도입니다.</p>
            </div>
          </div>
          <div class="box">
            <div class="card">
              <div class="icon" />
              <h2>5년이 지나면 소멸</h2>
              <p>법정 신고기한 5년 이내 신고한 세금에서 환급이 가능하기 때문에 기간이 지난 환급액은 소멸하게 됩니다.</p>
            </div>
          </div>
          <div class="box">
            <div class="card">
              <div class="icon" />
              <h2>매년 신설되는 제도와<br/>수시로 변경되는 세법</h2>
              <p>매년 조세 지원과 혜택을 변경 적용하여 개인이 확인하는 것은 매우 어렵습니다.</p>
            </div>
          </div>
          <div class="box">
            <div class="card">
              <div class="icon" />
              <h2>기본보수료 NO!</h2>
              <p>{{ serviceProviderName+particle }} 기본 보수료가 없으며, 세금 환급 정산 전 미리 수수료를 요구하지 않습니다.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="intro_section_3" class="intro_section">
      <div>
        <div class="intro_sub_wrap">
          <div>
            <h1 class="clr_black" :class="{on:animation.section3_1_on}">
              <span class="clr_blue">하나라도</span><br class="mobile_show"/> 해당된다면 조회해보세요.<span class="check"/>
            </h1>
            <ul>
              <li :class="{on:animation.section3_1_on}"><span class="check">&nbsp;</span> <span class="txt">최근 5년간 세금을 납부한 적이 있는 사용자</span></li>
              <li :class="{on:animation.section3_2_on}"><span class="check">&nbsp;</span> <span class="txt">직원을 채용한 적이 있는 사업자</span></li>
              <li :class="{on:animation.section3_3_on}"><span class="check">&nbsp;</span> <span class="txt">최근 1년간 세금 환급을 받은 적 없는 사업자</span></li>
              <li :class="{on:animation.section3_4_on}"><span class="check">&nbsp;</span> <span class="txt">절세 혜택에 대해 잘 알지 못하는 사업자</span></li>
            </ul>
          </div>
        </div>
        <div class="card_list">
          <div class="card">
            <h2><span v-if="showSection3ProviderName" class="clr_blue">{{ serviceProviderName }}</span>
                <br v-if="showSection3ProviderName" class="mobile_show"/> 예상 환급금 조회 절차
            </h2>
            <p>3분만에 환급금액 조회가능!</p>
            <p><span class="clr_red">실시간 환급금액 조회는<br/> 누구나 무료</span>입니다.</p>
            <div class="round_list">
              <div class="item" :class="{on:animation.section3_5_1_on}">
                <div class="round round1">
                  <div class="innerRound">
                    <h5>1</h5>
                    <p>카카오톡<br/>본인인증</p>
                  </div>
                </div>
                <div class="arrow arrow1" />
              </div>
              <div class="item" :class="{on:animation.section3_5_2_on}">
                <div class="round round2">
                  <div class="innerRound">
                    <h5>2</h5>
                    <p>3분 이내<br/>데이터 수집</p>
                  </div>
                </div>
                <div class="arrow arrow2" />
              </div>
              <div class="item" :class="{on:animation.section3_5_3_on}">
                <div class="round round3">
                  <div class="innerRound">
                    <h5>3</h5>
                    <p>예상 환급액<br/>확인</p>
                  </div>
                </div>
                <div class="arrow arrow3" />
              </div>
              <div class="item"  :class="{on:animation.section3_5_4_on}">
                <div class="round round4">
                  <div class="innerRound">
                    <h5>4</h5>
                    <p>경정청구<br/>신청</p>
                  </div>
                </div>
<!--                <div class="arrow arrow4" />-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="intro_section_4" class="intro_section">
      <div>
        <h1 class="clr_black">자주 묻는 FAQ 질문</h1>
        <div class="iphone_back">
          <div>
            <div class="comment_left">
              <p>Q. 기존에 이용하는 세무사가 있는데 {{ serviceProviderName }} 서비스를 이용할 수 있을까요?</p>
            </div>
            <div class="tip tip_left"></div>

            <div class="comment_right">
              <p><span>네, 가능합니다.</span><br/>세금 환급은 세금 환급 전문 세무사가 하는 것이 더 효율적입니다. 세금 환급에 한해 일회성으로 세무 업무를 진행하므로 기존 세무 대리인은 변경되지 않습니다.</p>
            </div>
            <div class="tip tip_right"></div>

            <div class="comment_left">
              <p>Q. 세무 조사 위험은 없나요?</p>
            </div>
            <div class="tip tip_left"></div>

            <div class="comment_right">
              <p><span>없습니다.</span><br/>세무 조사 대상자를 선정하는 기준은 국세기본법 제 81조 6항에 규정된 사항에만 선정됩니다. 세금 환급(경정청구) 신청은 누락된 공제 감면 사항에 대한 청구이므로, 세무 조사 대상자의 기준으로 규정되어 있지 않습니다.</p>
            </div>
            <div class="tip tip_right"></div>

            <div class="comment_left">
              <p>Q. 세금 환급까지 소요 시간은 얼마나 되나요?</p>
            </div>
            <div class="tip tip_left"></div>

            <div class="comment_right">
<!--              <p><span>{{ serviceProviderName+particle2 }} 통해 3분안에 예상 환급액 확인</span><br/>이 가능하며, 이후 국세청 승인 및 환급액 지급까지는 <span>2개월</span> 정도 소요됩니다.</p>-->
              <p><span>{{ serviceProviderName+particle2 }} 통해 3분안에 예상 환급액 확인</span>이 가능하며, 이후 국세청 승인 및 환급액 지급까지는 <span>2개월</span> 정도 소요됩니다.</p>
            </div>
            <div class="tip tip_right"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="intro_section_5" class="intro_section">
      <div>
        <div><img src="https://s3.ap-northeast-2.amazonaws.com/static.unicornranch.co.kr/allok/img/landing_intro/logo-semu.png"></div>
        <div><img src="https://s3.ap-northeast-2.amazonaws.com/static.unicornranch.co.kr/allok/img/landing_intro/logo-tax.png"></div>
        <div><img src="https://s3.ap-northeast-2.amazonaws.com/static.unicornranch.co.kr/allok/img/landing_intro/logo-work.png"></div>
      </div>
    </section> -->
    <section id="intro_section_6" class="intro_section">
      <div>
        <h1>{{ serviceProviderName }}<small>{{particle}}</small></h1>
        <h2>AI솔루션이 한 번,<br class="tablet_show"/> 전문 세무팀이 또 한 번 검토합니다.</h2>
        <button @click="mixFnTax">예상 환급액 무료 조회</button>
      </div>
    </section>
  </div>

</template>

<script>
import serviceMix from '../../../../mixins/partner/serviceMix'
export default {
  props:{
    partnerName:{
      type:String,
    },
    particle:{
      type:String,
      default:'는',
    },
    particle2:{
      type:String,
      default:'를',
    },
    useSection1Slot:{
      type:Boolean,
      default: false
    },
    showSection3ProviderName:{
      type:Boolean,
      default: true
    }
  },
  mixins:[serviceMix],
  created() {
    if(this.partnerName){
      this.serviceProviderName=this.partnerName;
    }
  },
  data(){
    return {
      serviceProviderName:'다된다.',
      money:'0,000,000',
      animation:{
        section1_1_on:false,
        section2_1_on:false,
        section3_1_on:false,
        section3_2_on:false,
        section3_3_on:false,
        section3_4_on:false,
        section3_5_1_on:false,
        section3_5_2_on:false,
        section3_5_3_on:false,
        section3_5_4_on:false,
      }
    }
  },
  methods:{

    setMoneyFormat(strMoney, unit) {
      var rtv = strMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + unit;
      return rtv;
    },
    rollingNumber(){
      setTimeout(() => this.counter(80473000), 100);
    },
    counter(max){
      let now = max;
      const handle = setInterval(() => {
        this.money = this.setMoneyFormat(Math.ceil(max - now), "");
        if (now < 1) {
          clearInterval(handle);
        }

        const step = now / 10;
        now -= step;
      }, 20);
    }
  },
  mounted() {
    this.animation.section1_1_on=true;
    this.animation.section2_1_on=true;

    const section3 = document.querySelector("#intro_section_3").getBoundingClientRect();
    const animation_section3_start_position = parseInt(section3.top);

    const section3_2 = document.querySelector("#intro_section_3 .card_list").getBoundingClientRect();
    const animation_section3_2_start_position = parseInt((section3_2.top)+30);

    window.addEventListener("scroll",e=>{
      const currentPosition = window.scrollY + window.innerHeight;
      if(currentPosition > animation_section3_start_position){
        if(!this.animation.section3_1_on){
          this.animation.section3_1_on=true;
          setTimeout(()=> this.animation.section3_2_on=true, 300)
          setTimeout(()=> this.animation.section3_3_on=true, 600)
          setTimeout(()=> this.animation.section3_4_on=true, 900)
        }
      }
      if(currentPosition > animation_section3_2_start_position){
        if(!this.animation.section3_5_1_on){
          this.animation.section3_5_1_on=true;
          setTimeout(()=> this.animation.section3_5_2_on=true, 1000)
          setTimeout(()=> this.animation.section3_5_3_on=true, 2000)
          setTimeout(()=> this.animation.section3_5_4_on=true, 3000)
        }
      }
    });
    this.rollingNumber();
  },
}
</script>

<style scoped>
@import "~/static/css/landing_intro.css";
/*@import "https://s3.ap-northeast-2.amazonaws.com/static.unicornranch.co.kr/ifs/css/landing_intro.css";*/
</style>
